<form [formGroup]="form">
  <mat-sidenav-container class="sidenav">
    <mat-sidenav #sidenav [opened]="model.open" (keydown.escape)="close()" mode="over" fixedInViewport="true"
      position="end">
      <div #header class="sidenav-header header-title" fxFlex="none" fxLayout="row"
        fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div>{{ "flows.list.title" | translate }}</div>
          <div> / </div>
          <div class="second-text">{{ "flows.createAbTest.config" | translate }}</div>
        </div>
        <div class="close" (click)="close()" color="warn" fxLayoutAlign="center center">
          <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
        </div>
      </div>
      <div appearance="outlined" fxLayout="column" class="ab-container">
        <mat-card>
          <div *ngIf="isLive" class="live" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="indicator">
              <div class="bullet success"></div>
              <div class="text">{{ "flows.createAbTest.liveInfo.live" | translate }}</div>
            </div>
            <div class="infos" *ngIf="model.selector_test.days_running > 1" fxLayout="row" fxLayoutAlign="center center"
              fxLayoutGap="30px">
              <div class="days-live">
                <div class="number">{{ model.selector_test.days_running }}</div>
                <div class="text">{{ "flows.createAbTest.liveInfo.daysLive" | translate }}</div>
              </div>
              <!-- <div class="transactions">
                <div class="number">876.438</div>
                <div class="text">{{ "flows.createAbTest.liveInfo.transactions" | translate }}</div>
              </div> -->
            </div>
          </div>
          <div class="input-div">
            <div class="a-test">
              <div class="icon">A</div>
              <mat-form-field fxLayoutGap="10px" fxFlex="80%">
                <mat-label>
                  {{ "flows.createAbTest.versionATitle" | translate }}
                </mat-label>
                <input matInput type="text" formControlName="titleA" maxlength="255" />
              </mat-form-field>

              <mat-form-field fxLayoutGap="10px" fxFlex="80%">
                <textarea formControlName="descriptionA" maxlength="255" readonly matInput></textarea>
                <mat-hint>{{ "flows.createAbTest.hints.cannotEdit" | translate }}</mat-hint>
              </mat-form-field>
            </div>
            <div class="b-test">
              <div class="icon">B</div>
              <mat-form-field fxLayoutGap="10px" fxFlex="80%">
                <mat-label>
                  {{ "flows.createAbTest.versionBTitle" | translate }}
                </mat-label>
                <input matInput type="text" formControlName="titleB" maxlength="255" />
              </mat-form-field>

              <mat-form-field fxLayoutGap="10px" fxFlex="80%">
                <textarea formControlName="descriptionB" maxlength="255" matInput></textarea>
                <mat-hint>{{ "flows.createAbTest.hints.describe" | translate }}</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="distribution-div">
            <div class="row">
              <div class="title">
                <div class="principal">
                  {{ "flows.createAbTest.distribution.title" | translate }}
                </div>
                <div class="secondary">
                  {{ "flows.createAbTest.distribution.subtitle" | translate }}
                </div>
              </div>

              <mat-form-field>
                <div class="percentage">
                  <div class="input">
                    <input matInput formControlName="percentage" type="text" pattern="\d*" maxlength="3" max="100"
                      (input)="change($event)" />
                  </div>
                  <div class="box">%</div>
                </div>
              </mat-form-field>
            </div>

            <div class="allocation-slider" fxLayout="column" fxFlex="100">
              <mat-form-field>
                <mat-slider color="primary" [max]="max" [min]="min" [step]="step" [discrete]="thumbLabel" fxFlex="100"
                  [showTickMarks]="showTicks">
                  <input matInput matSliderThumb (input)="change($event)" #slider formControlName="percentage">
                </mat-slider>
              </mat-form-field>

              <div class="ruler fs-10 fc-9" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="stick" fxLayoutAlign="center center">
                  <div>0%</div>
                </div>
                <div class="stick half" fxLayoutAlign="center center">
                  <div></div>
                </div>
                <div class="stick" fxLayoutAlign="center center">
                  <div>25%</div>
                </div>
                <div class="stick half" fxLayoutAlign="center center">
                  <div></div>
                </div>
                <div class="stick" fxLayoutAlign="center center">
                  <div>50%</div>
                </div>
                <div class="stick half" fxLayoutAlign="center center">
                  <div></div>
                </div>
                <div class="stick" fxLayoutAlign="center center">
                  <div>75%</div>
                </div>
                <div class="stick half" fxLayoutAlign="center center">
                  <div></div>
                </div>
                <div class="stick" fxLayoutAlign="center center">
                  <div>100%</div>
                </div>
              </div>
            </div>
            <div class="description-div">
              <div class="description-bar">
                <div class="a-bar" *ngIf="flow_version_a_percentage > 0" [style.width.%]="flow_version_a_percentage">
                  <div class="value a">{{ flow_version_a_percentage }}%</div>
                </div>
                <div class="b-bar" *ngIf="flow_version_b_percentage > 0" [style.width.%]="flow_version_b_percentage">
                  <div class="value b">{{ flow_version_b_percentage }}%</div>
                </div>
                <div class="control-bar" *ngIf="flow_version_control_percentage > 0"
                  [style.width.%]="flow_version_control_percentage">
                  <div class="value control">{{ flow_version_control_percentage }}%</div>
                </div>
              </div>

              <div class="description" fxLayout="row">
                <div class="version">
                  <div class="circle a"></div>
                  <div>{{ "flows.createAbTest.distribution.versionA" | translate }}</div>
                </div>
                <div class="version">
                  <div class="circle b"></div>
                  {{ "flows.createAbTest.distribution.versionB" | translate }}
                </div>
                <div class="version">
                  <div class="circle control"></div>
                  <div>{{ "flows.createAbTest.distribution.versionControl" | translate }}</div>
                </div>
              </div>
            </div>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center" [ngClass]="{'space-between': model.action == 'manage'}"
            class="buttons">
            <button mat-stroked-button class="btn-secondary" *ngIf="model.action =='manage'"
              [disabled]="model.selector_test.status != 1 || !(model.canCancelTestAB)" (click)="cancelTestAb()">
              <span>{{ "flows.createAbTest.buttons.cancel" | translate }}</span>
            </button>

            <button [disabled]="!form.valid" class="create-test-ab-btn" *ngIf="model.action =='create'"
              (click)="createTestAb()" fxLayout="row" fxFlex.lt-md="100" fxLayoutAlign="center" fxLayout="row"
              mat-flat-button color="primary">
              {{ "flows.createAbTest.buttons.create" | translate }}
            </button>

            <button [disabled]="!form.valid" class="save-test-ab-btn" *ngIf="model.action == 'manage'" type="submit"
              fxLayout="row" (click)="saveTestAb()" fxFlex.lt-md="100" fxLayoutAlign="center" fxLayout="row"
              mat-flat-button color="primary">
              {{ "flows.createAbTest.buttons.save" | translate }}
            </button>
          </div>
        </mat-card>

        <div *ngIf="!isLive" class="obs">{{ "flows.createAbTest.obs.title" | translate }}</div>
        <div *ngIf="isLive" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="live-description">
          <div class="created-by">
            <div class="text">{{ "flows.createAbTest.obs.created" | translate }}</div>
            <div class="date">{{ model.selector_test.start_date | date:"dd MMM yy, HH:mm" }} - {{
              model.selector_test.last_user_name }}</div>
          </div>
          <!-- <div class="data">
            <div class="name"></div>
            <div class="email">{{ model.selector_test.last_user_name }}</div>
          </div> -->
        </div>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</form>
